import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { ItemStoreEvents } from "../itemStore.store";
import { useChartStore } from "../charts/charts.store";
import type { Subset } from "@/helpers/utility/Type";
import { splitUid } from "@/helpers/utility/Id";
import type { ChartItem } from "../charts/ChartItem";

export const chartDefaults: Subset<ChartItem> = {
  chartType: "bar",
  chartSettings: {
    scaleColorsVisible: false,
    roundEffectsVisible: false
  }
};

export const sceneChartStoreHooks: Partial<ItemStoreEvents<SceneNodeItem<"chart">>> = {
  async beforeDuplicate(item, changes, sourceItem) {
    const extraChanges: Subset<SceneNodeItem<"chart">> = {};
    const chartStore = useChartStore();
    if (item.data?.chartUid == sourceItem.data.chartUid) {
      const { id } = splitUid(item.data.chartUid);
      const newChart = await chartStore.duplicate(id);
      extraChanges.data = {
        chartUid: newChart.uid
      };
    }
    return extraChanges;
  },
  async afterDelete(item) {
    const chartStore = useChartStore();
    await chartStore.delete({ uid: item.data.chartUid });
  }
};
